import { DebugContext } from '@/contexts/_shared/DebugContext';
import { useCallback, useContext } from 'react';

export function useLogger() {
  // Prefer context default over useDebug() so loggers work outside DebugProvider.
  const { isDebugEnabled } = useContext(DebugContext);
  const debugLogsEnabled = isDebugEnabled || import.meta.env.DEV;

  const logError = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.error(`[WX Error]: ${message}`, ...optionalParams);
    },
    [],
  );

  const logWarn = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.warn(`[WX Warning]: ${message}`, ...optionalParams);
    },
    [],
  );

  const logInfo = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      console.info(`[WX Info]: ${message}`, ...optionalParams);
    },
    [],
  );

  const logDebug = useCallback(
    (message?: unknown, ...optionalParams: unknown[]) => {
      if (!debugLogsEnabled) return;
      console.debug(`[WX Debug]: ${message}`, ...optionalParams);
    },
    [debugLogsEnabled],
  );

  return {
    logError,
    logWarn,
    logInfo,
    logDebug,
  };
}
